var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"m-fab-anchor"},[_c('button',{ref:"fab",staticClass:"m-fab",attrs:{"type":"button","aria-label":_vm.label,"title":_vm.label},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{class:['fas', 'fa-' + _vm.icon],attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }